import { ColumnDef } from '@tanstack/react-table';
import { formatPhone } from 'src/utils/format-phone';
import { RouterOutput } from 'src/trpc';
import { InvoiceStatus } from '@libs/schemas';
import { format } from 'date-fns';
import { InvoiceStatusBadge } from './InvoiceStatusBadge';
import { MoneyFromCents } from '@libs/services/money';
import { Button } from '@/components/ui/button';
import { ArrowUpDown, ChevronDown, ChevronUp } from 'lucide-react';

export const InvoiceColumns: ColumnDef<
  RouterOutput['admin']['invoice']['adminListInvoices']['invoices'][0]
>[] = [
  {
    accessorKey: 'friendlyId',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className="h-auto p-0 font-semibold hover:bg-transparent"
        >
          Invoice Number
          {column.getIsSorted() === 'asc' ? (
            <ChevronUp className="ml-2 h-4 w-4" />
          ) : column.getIsSorted() === 'desc' ? (
            <ChevronDown className="ml-2 h-4 w-4" />
          ) : (
            <ArrowUpDown className="ml-2 h-4 w-4" />
          )}
        </Button>
      );
    },
  },
  {
    header: 'Customer',
    accessorFn: (row) => `${row.user?.name?.first || ''} ${row.user?.name?.last || ''}`,
  },
  {
    header: 'Email',
    accessorKey: 'user.email',
  },
  {
    header: 'Phone Number',
    accessorFn: (row) => formatPhone(row.user?.phone || ''),
  },
  {
    accessorKey: 'dueDate',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className="h-auto p-0 font-semibold hover:bg-transparent"
        >
          Due Date
          {column.getIsSorted() === 'asc' ? (
            <ChevronUp className="ml-2 h-4 w-4" />
          ) : column.getIsSorted() === 'desc' ? (
            <ChevronDown className="ml-2 h-4 w-4" />
          ) : (
            <ArrowUpDown className="ml-2 h-4 w-4" />
          )}
        </Button>
      );
    },
    cell: (row) => {
      const dueDate = row.getValue() as string;
      return dueDate ? `${format(dueDate, 'MM/dd/yyyy')}` : 'N/A';
    },
  },
  {
    accessorKey: 'totalInCents',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className="h-auto p-0 font-semibold hover:bg-transparent"
        >
          Total
          {column.getIsSorted() === 'asc' ? (
            <ChevronUp className="ml-2 h-4 w-4" />
          ) : column.getIsSorted() === 'desc' ? (
            <ChevronDown className="ml-2 h-4 w-4" />
          ) : (
            <ArrowUpDown className="ml-2 h-4 w-4" />
          )}
        </Button>
      );
    },
    cell: (row) => {
      const totalInCents = row.getValue() as number;
      return MoneyFromCents(totalInCents || 0).toFormat();
    },
  },
  {
    accessorKey: 'status',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className="h-auto p-0 font-semibold hover:bg-transparent"
        >
          Status
          {column.getIsSorted() === 'asc' ? (
            <ChevronUp className="ml-2 h-4 w-4" />
          ) : column.getIsSorted() === 'desc' ? (
            <ChevronDown className="ml-2 h-4 w-4" />
          ) : (
            <ArrowUpDown className="ml-2 h-4 w-4" />
          )}
        </Button>
      );
    },
    cell: (row) => {
      const status = row.getValue() as InvoiceStatus;

      return (
        <div className="flex items-center gap-2">
          <InvoiceStatusBadge status={status} />
        </div>
      );
    },
  },
];
